import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["initialValue", "isEditing", "label", "maxLength", "minLength", "onValidated", "onValueChanged", "password", "required", "textarea", "type", "validate", "validationExpression"];
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import { Input } from "../../controls/formik-wrapped";
export var TextField = function TextField(_ref) {
  var initialValue = _ref.initialValue,
      isEditing = _ref.isEditing,
      label = _ref.label,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      onValidated = _ref.onValidated,
      onValueChanged = _ref.onValueChanged,
      password = _ref.password,
      required = _ref.required,
      textarea = _ref.textarea,
      type = _ref.type,
      validate = _ref.validate,
      validationExpression = _ref.validationExpression,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      validReason = _useState6[0],
      setValidReason = _useState6[1];

  var previousValue = useRef(initialValue);
  var validationSchema = useMemo(function () {
    var input = Yup.string().ensure().trim();
    if (required) input = input.required();
    if (minLength) input = input.min(minLength);
    if (maxLength) input = input.max(maxLength);
    if (validationExpression) input = input.matches(validationExpression);
    if (validate) input = input.test("custom", "${message}", function (value, testContext) {
      var validated = validate(value);

      if (!validated.valid) {
        testContext.createError({
          message: validated.reason
        });
      }

      return validated.valid;
    });
    return Yup.object({
      input: input
    });
  }, [maxLength, minLength, required, validate, validationExpression]);
  useEffect(function () {
    if (isValid === undefined) return;
    if (previousValue.current === currentValue) return;
    previousValue.current = currentValue;

    if (onValidated) {
      onValidated({
        value: currentValue,
        valid: isValid,
        reason: validReason
      });
    }

    if (isValid) {
      onValueChanged(currentValue);
    }
  }, [currentValue, isValid, onValidated, onValueChanged, validReason]);
  var Component = password ? Input.Password : textarea ? Input.Textarea : Input;
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      input: initialValue !== null && initialValue !== void 0 ? initialValue : ""
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(_values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      setSubmitting(false);
    }
  }, function (_ref3) {
    var isSubmitting = _ref3.isSubmitting,
        isValid = _ref3.isValid,
        values = _ref3.values,
        errors = _ref3.errors;
    setIsValid(isValid);
    if (isValid && currentValue !== values.input) setCurrentValue(values.input);
    setValidReason(errors.input);
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("label", null, label && /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
      type: type,
      name: "input",
      disabled: isSubmitting || isEditing === false
    }))), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "input",
      component: "div"
    }));
  });
};